export const INTENT_TAG_MODE = {
  REGULAR: 'regular',
  FORCED: 'forced',
}

export const EXTRACT_FIELD_TYPE = {
  ENUM: 'enum',
  TEXT: 'text',
  NUMBER: 'number',
}

export const EXTRACT_FIELD_TYPE_OPTIONS = [
  { value: EXTRACT_FIELD_TYPE.ENUM, label: '枚举（单选）' },
  { value: EXTRACT_FIELD_TYPE.TEXT, label: '文本' },
  { value: EXTRACT_FIELD_TYPE.NUMBER, label: '数值' },
]

export const RATING_CONDITION_OPERATOR = {
  EQ: 'eq',
  COLLECTED: 'collected',
}

export const RATING_CONDITION_OPERATOR_OPTIONS = [
  { value: RATING_CONDITION_OPERATOR.EQ, label: '等于' },
  { value: RATING_CONDITION_OPERATOR.COLLECTED, label: '已采集' },
]

export const EXTRACT_INSTRUCTION_MAX_LENGTH = 2000

/** 枚举类型「允许的值」最多条数 */
export const EXTRACT_ALLOWED_VALUES_MAX_COUNT = 10

/** 信息采集名称后缀，完整名称为：{话术名称}-采集表单 */
export const EXTRACT_FORM_NAME_SUFFIX = '采集表单'
export const EXTRACT_FORM_NAME_MAX_LENGTH = 50

export const INTENT_JUDGE_TYPE = {
  PROMPT: 'prompt',
  RULE: 'rule',
}

/** 添加表单下拉：提示词 / 系统指标 */
export const INTENT_FORM_TYPE = {
  PROMPT: 'prompt',
  SYSTEM: 'system',
}

export const INTENT_FORM_TYPE_OPTIONS = [
  { value: INTENT_FORM_TYPE.PROMPT, label: '提示词' },
  { value: INTENT_FORM_TYPE.SYSTEM, label: '系统指标' },
]

export const INTENT_CONDITION_OPERATOR = {
  EQ: 'eq',
  NEQ: 'neq',
  GT: 'gt',
  LT: 'lt',
  GTE: 'gte',
  LTE: 'lte',
  CONTAINS: 'contains',
  FILLED: 'filled',
  EMPTY: 'empty',
}

export const INTENT_CONDITION_OPERATOR_LABELS = {
  [INTENT_CONDITION_OPERATOR.EQ]: '等于',
  [INTENT_CONDITION_OPERATOR.NEQ]: '不等于',
  [INTENT_CONDITION_OPERATOR.GT]: '大于',
  [INTENT_CONDITION_OPERATOR.LT]: '小于',
  [INTENT_CONDITION_OPERATOR.GTE]: '大于等于',
  [INTENT_CONDITION_OPERATOR.LTE]: '小于等于',
  [INTENT_CONDITION_OPERATOR.CONTAINS]: '包含',
  [INTENT_CONDITION_OPERATOR.FILLED]: '已采集',
  [INTENT_CONDITION_OPERATOR.EMPTY]: '未采集',
}

/** 常规模式内置系统指标字段 */
export const INTENT_SYSTEM_FIELDS = [
  {
    fieldId: 'sys_duration',
    name: '通话时长(秒)',
    type: EXTRACT_FIELD_TYPE.NUMBER,
    unit: '秒',
    valuePlaceholder: '如：30',
  },
  {
    fieldId: 'sys_voice_assistant',
    name: '语音助手拦截',
    type: EXTRACT_FIELD_TYPE.ENUM,
    allowedValues: ['是', '否'],
  },
  {
    fieldId: 'sys_round',
    name: '对话轮次',
    type: EXTRACT_FIELD_TYPE.NUMBER,
    valuePlaceholder: '如：3',
  },
  {
    fieldId: 'sys_caller_hangup',
    name: '是否主叫挂机',
    type: EXTRACT_FIELD_TYPE.ENUM,
    allowedValues: ['是', '否'],
  },
]
